export const prefixPlusIfNeeded = str =>
  str.charAt(0) === '+' ? str : `+${str}`;



// WEBPACK FOOTER //
// ./app/utils/phone.js